<ng-template>
  <div
    (click)="closed.emit()"
    class="flex w-fit flex-col rounded-md border border-slate-200 bg-white shadow-md"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
